import cx from 'classnames';
import React, {useCallback, useContext} from 'react';
import {useSelector} from 'react-redux';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {Card} from '~/common/canvas/Card/Card';
import {useInMwEditDesignButtonAbTest} from '~/common/hooks/useInMwEditDesignButtonAbTest';
import {selectEditingMobile} from '~/CreateFabricGreetingCard/reducers/fabricDesign/selectors';
import {Envelope} from '~/CreateFabricInvitation/components/Envelope/Envelope';
import {selectFabricArt} from '~/CreateFabricInvitation/reducers/fabricDesign/selectors';
import {useStamp} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Stamp/actions/useStamp';
import {EventCreateStampContext} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/Stamp/EventCreateStampContext';
import {Sections} from '~/CreateFabricInvitation/routes/EventCreateDesign/constants';

import {largishAndUp} from '~libSass/base/_exports.sass';
import './Stamp.sass';

export const Stamp = () => {
  const {canvas} = useContext(EventCreateStampContext);
  const fabricArt = useSelector(selectFabricArt);
  const {selectedStamp} = useStamp();
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const editingMobile = useSelector(selectEditingMobile);
  const isInEditButtonTest = useInMwEditDesignButtonAbTest();

  const refreshCanvasDimensions = useCallback(() => {
    canvas?.setCurrentDimensions();
  }, [canvas]);

  return (
    <div
      className={cx('card-template', 'stamp', {
        'stamp--editing--mobile': editingMobile,
        'onestep-edit-ABTest__card-wrapper': isInEditButtonTest,
      })}
    >
      <div className="stamp__images">
        <Card
          className="stamp__images__card"
          fabricArt={fabricArt}
          redirectTo={isDesktop ? Sections.CARD_DESIGN : null}
          parentNode={`${!isDesktop ? 'create-container' : ''}`}
        />
        <Envelope
          type="image"
          className="stamp__images__envelope"
          id="canvas__wrapper__stickers"
          selectedStamp={selectedStamp?.image}
          message="Guest's name will go here"
          canvas
          onLoad={refreshCanvasDimensions}
          forceShowEnvelope
        />
      </div>
    </div>
  );
};
